import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  background-color: var(--color-white);
`

export const Addresses = styled.div`
  ${tw`grid gap-8 p-8`};
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
`
